import React, { Component } from 'react';
import { Link } from 'react-router-dom'

// import logo from '../../assets/img/logo-2.png'
import logo from '../../assets/img/logo.png'
// import shape1 from '../../assets/img/lines/01.png'
import shape2 from '../../assets/img/lines/02.png'

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}

class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="container">
                    <div className="footer-widget">
                        <div className="row">
                            <div className="col-lg-4 col-sm-5 order-1">
                                <div className="widget site-info-widget">
                                    <div className="footer-logo">
                                        <img src={logo} alt="" />
                                    </div>
                                    <p>A visionary leader, entrepreneur, and philanthropist.</p>

                                </div>
                            </div>
                            {/* <div className="col-lg-8 col-sm-7 order-2">
                                <div className="widget newsletter-widget">
                                    <h4 className="widget-title">Subscribe Our Newsletters</h4>
                                    <div className="newsletter-form">
                                        <form action="#">
                                            <input type="email" placeholder="Enter Your Email" />
                                            <button type="submit" className="main-btn">Subscribe Now</button>
                                        </form>
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-lg-3 col-sm-6 order-3">
                                <div className="widget nav-widget">
                                    <a href='/about'>
                                        <h4 className="widget-title">About</h4>
                                    </a>
                                    <ul>
                                        {/* <li><Link to="#">About J.W. Oliver Jr</Link></li> */}
                                        <li><a href="https://globalteambook.com/" target='_blank' rel="noopener noreferrer">Books</a></li>
                                        <li><Link to="/blog">Blog</Link></li>
                                        <li><Link to="/podcasts">Podcasts</Link></li>
                                        {/* <li><Link to="/companies">Companies</Link></li> */}
                                        <li><Link to="/properties">Luxury Properties</Link></li>

                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-5 order-lg-4 order-5">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="widget nav-widget">
                                            <a href='/companies'>
                                                <h4 className="widget-title">Companies</h4>
                                            </a>
                                            <ul>
                                                <li><a href="https://www.globalimpact-now.com/" target='_blank' rel="noopener noreferrer">Global Impact</a></li>
                                                <li><a href="https://www.zimworx.com/" target='_blank' rel="noopener noreferrer">ZimWorX</a></li>
                                                <li><a href="https://wesupportministries.com/" target='_blank' rel="noopener noreferrer">We Support Ministries</a></li>
                                                <li><a href="https://www.supportdds.com/" target='_blank' rel="noopener noreferrer">SupportDDS</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <div className="widget contact-widget">
                                            <h4 className="widget-title">Contact</h4>
                                            {/* <p>Untrammelled &amp; nothing preven our being able</p> */}
                                            <ul className="contact-infos">
                                                <li>
                                                    <Link to="/time">
                                                        <i className="far fa-phone" />
                                                        Schedule Call
                                                    </Link>
                                                </li>
                                                <li>
                                                    <a href="mailto:info@jwoliver.com">
                                                        <i className="far fa-envelope-open" />
                                                        info@jwoliver.com
                                                    </a>
                                                </li>
                                                {/* <li> <i className="far fa-map-marker-alt" /> Broklyn Street USA</li> */}
                                            </ul>

                                            <ul className="social-links">
                                                <li><a href="https://www.facebook.com/jw.oliver.12" target='_blank' rel="noopener noreferrer"><i className="fab fa-facebook-f fa-2x" /></a></li>
                                                {/* <li><a href="#" target='_blank' rel="noopener noreferrer"><i className="fab fa-twitter fa-2x"/></a></li> */}
                                                <li><a href="https://www.instagram.com/jwoliverjr/" target='_blank' rel="noopener noreferrer" ><i className="fab fa-instagram fa-2x" /></a></li>
                                                <li><a href="https://www.linkedin.com/in/j-w-oliver-jr-28023213" target='_blank' rel="noopener noreferrer"><i className="fab fa-linkedin fa-2x" /></a></li>
                                                {/* <li><a href="https://www.youtube.com/channel/UCKtaHivvgwnjauwkH1YgHyQ" target='_blank' rel="noopener noreferrer"><i className="fab fa-youtube fa-2x" /></a></li> */}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-lg-4 col-sm-6 order-lg-5 order-4">
                                <div className="widget insta-feed-widget">
                                    <h4 className="widget-title">Follow Instagram</h4>
                                    <div className="insta-images">
                                        {instapost.map((item, i) => (
                                            <div key={i} className="insta-img" style={{ backgroundImage: "url(" + item.img + ")" }}>
                                                <Link to="#">
                                                    <i className="fab fa-instagram" />
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="footer-copyright">
                        <p className="copyright-text">
                            <span>Copyright <Link to="#">J.W. Oliver Jr.</Link> 2023</span>
                            <span>All Right Reserved | Made with <i className="far fa-heart" /> by <Link to="#">ZimWorX</Link></span>
                        </p>
                        <Link to="#" className="back-to-top" onClick={scrollToTop}><i className="far fa-angle-up" /></Link>
                    </div>
                </div>
                {/* Lines */}
                {/* <img src={shape1} alt="line" className="line-one" /> */}
                <img src={shape2} alt="line" className="line-two" />
            </footer>
        );
    }
}

export default Footer;